import { IframeHTMLAttributes } from "react";

type PageIframeProps = {
  customHeight?: string;
} & IframeHTMLAttributes<HTMLIFrameElement>;

export const PageIframe = ({ customHeight, ...props }: PageIframeProps) => {
  return (
    <iframe
      {...props}
      scrolling="yes"
      style={{
        height: customHeight ?? "100vh",
        width: "100vw",
        border: "none"
      }}
    />
  );
};
